import React from 'react'

import '../styles/index.scss'

import Layout from '../components/layout'
import SEO from '../components/seo'
import Nav from '../components/nav'
import OptBtn from '../components/button'
import PricingCard from '../components/content/pricingCard'

import bannerImg from '../images/pricing/bannerPricing.png'

function Pricing ({ lang }) {
    const text = {
        es: {
            page_title: 'Optiwe - Precios',
            page_description:
        'Lista de precios y planes mensuales para los productos de Optiwe',
            page_lang: 'es',
            h1_normal:
        'Planes a la medida que tu empresa necesita para crecer las ventas',
            h1_description_1:
        'Tenemos un plan específico para cada etapa de tu empresa, desde paquetes básicos para atender conversaciones con múltiples asesores en WhatsApp de manera centralizada, hasta chatbots para automatizar tus ventas y acciones de marketing automatizadas en WhatsApp para aumentar tus ventas. ',
            demo: 'Agendar demo',
            test: 'Probar gratis',
            create_account: 'Probar gratis!',
            starter: 'Starter',
            starter_limit_1_name: 'Mínimo 2 agentes de atención',
            starter_limit_1_quantity: 'USD 10 / mes',
            starter_limit_2_name: 'Agrega el canal WhatsApp por $20 USD / mes',
            starter_channels_1: 'WhatsApp, Instagram',
            starter_channels_2: 'Facebook y Chat Web',
            starter_feature_0: 'Incluye 1000 conversaciones / mes',
            starter_feature_1: 'Soporte por WhatApp y Email',
            starter_feature_2: 'Atención multiagente',
            starter_feature_3: 'CRM para gestión de clientes',
            starter_feature_4: 'Reportes y auditoría',
            starter_feature_5: 'Envíos masivos por WhatsApp',
            starter_feature_6: 'Chatbots captura de leads',
            team: 'Team',
            team_limit_1_name: 'Mínimo 4 agentes de atención',
            team_limit_1_quantity: 'USD 15 / mes',
            team_limit_2_name: 'Agrega el canal WhatsApp por $20 USD / mes',
            team_channels_1: 'WhatsApp, Instagram',
            team_channels_2: 'Facebook y Chat Web',
            team_feature_0: 'Incluye 3000 conversaciones / mes',
            team_feature_1: 'Soporte por WhatApp y Email',
            team_feature_2: 'Atención multiagente',
            team_feature_3: 'CRM para gestión de clientes',
            team_feature_4: 'Reportes y auditoría',
            team_feature_5: 'Envíos masivos por WhatsApp',
            team_feature_6: 'Chatbots captura de leads',
            team_feature_7: 'Chatbots derivación departamentos',
            team_feature_8: 'Chatbots preguntas frecuentes',
            team_feature_9: 'Integraciones con otros sistemas',
            scale: 'Scale',
            scale_limit_1_name: 'Mínimo 6 agentes de atención',
            scale_limit_1_quantity: 'USD 20 / mes',
            scale_limit_2_name: 'Agrega el canal WhatsApp por $20 USD / mes',
            scale_channels_1: 'WhatsApp, Instagram',
            scale_channels_2: 'Facebook y Chat Web',
            scale_feature_0: 'Incluye 6000 conversaciones / mes',
            scale_feature_1: 'Soporte por WhatApp y Email',
            scale_feature_2: 'Atención multiagente',
            scale_feature_3: 'CRM para gestión de clientes',
            scale_feature_4: 'Reportes y auditoría',
            scale_feature_5: 'Envíos masivos por WhatsApp',
            scale_feature_6: 'Chatbots captura de leads',
            scale_feature_7: 'Chatbots derivación departamentos',
            scale_feature_8: 'Chatbots preguntas frecuentes',
            scale_feature_9: 'Integraciones con otros sistemas',
            scale_feature_10: 'Diseñador avanzado de chatbots',
            scale_feature_11: 'Acceso a la API de Optiwe',
            scale_feature_12: 'ChatGPT - $50 USD / mes',
            whatsapp_pricing: 'Precios oficiales de WhatsApp Business API',
            whatsapp_pricing_1:
        'Optiwe solo utiliza los precios oficiales de Meta, no pagues de más por usar WhatsApp Business API.',
            whatsapp_pricing_2:
        'Meta define un precio por conversción y cada conversación dura un periodo de 24 horas.',
            whatsapp_pricing_3:
        'Los precios dependen del país y también dependen de si es una conversación iniciada por un cliente o por la empresa.',
            whatsapp_pricing_4: 'Las primeras 1000 conversaciones iniciadas por clientes son gratuitas.',
            conversations_pricing_title: 'Agrega más conversaciones a tu plan',
            conversations_pricing_text_1: 'Desde $0.02 USD por conversación (entrante o saliente).',
            conversations_pricing_text_2: 'Consulta nuestros descuentos por volumen.',
            chatgpt_pricing_title: 'Potencia tus chatbots con ChatGPT',
            chatgpt_pricing_text_1: 'Solo en el Plan Scale. Desde $50 USD por mes.',
            chatgpt_pricing_text_2: 'Integra ChatGPT con todo el conocimiento de tu empresa.',
            select_plan: 'Elegí tu plan según lo que necesites',
            features: 'Características',
            price_per_agent: 'Precio por agente de atención',
            price_per_agent_1: '$10 USD / mes',
            price_per_agent_2: '$15 USD / mes',
            price_per_agent_3: '$20 USD / mes',
            minimum: 'Cantidad mínima de agentes',
            whatsapp_channel_price: 'Precio del canal WhatsApp por línea',
            whatsapp_channel_price_1: '$20 USD / mes',
            whatsapp_channel_price_2: '$20 USD / mes',
            whatsapp_channel_price_3: '$20 USD / mes',
            feat_1: 'WhatsApp Business API',
            feat_2: 'Instagram DM',
            feat_3: 'Facebook Messenger',
            feat_4: 'Chat web',
            feat_5: 'Iconos Webs',
            feat_6: 'Módulo de atención multiagente',
            feat_7: 'Etiquetas de chats',
            feat_8: 'Módulo CRM',
            feat_9: 'Módulo Reportes',
            feat_10: 'Envíos masivos',
            feat_11: 'WhatsApp Marketing',
            feat_12: 'Chatbot captura de leads',
            feat_13: 'Chatbot derivación departamento',
            feat_14: 'Chatbot preguntas frecuentes',
            feat_15: 'Performance de Agentes',
            feat_16: 'Integraciones con otros sistemas',
            feat_17: 'Diseñador de chatbots avanzandos',
            feat_18: 'Chatbots potenciados por ChatGPT',
            feat_19: 'Acceso a la API',
            feat_20: 'Integraciones a medida',
            talk: '¡Hablemos!'
        },
        en: {
            page_title: 'Optiwe - Prices',
            page_description: 'Price list and monthly plans for Optiwe products',
            page_lang: 'en',
            h1_normal: 'Tailored plans that your company needs to increase sales',
            h1_description_1:
        'We have a specific plan for each stage of your company, from basic packages to centralize conversations with multiple WhatsApp advisors, to chatbots to automate your sales and automated marketing actions on WhatsApp to increase your sales.',
            demo: 'Schedule demo',
            test: 'Try for free',
            create_account: 'Try for free!',
            starter: 'Starter',
            starter_limit_1_name: '2 users minimum',
            starter_limit_1_quantity: '$ 10/month',
            starter_limit_2_name: 'Add WhatsApp for $20 / month',
            starter_channels_1: 'WhatsApp, Instagram',
            starter_channels_2: 'Facebook and Web Chat',
            starter_feature_0: '1000 conversations / month',
            starter_feature_1: 'Support via WhatsApp and email',
            starter_feature_2: 'Shared Inbox',
            starter_feature_3: 'CRM for customer management',
            starter_feature_4: 'Reports and audit',
            starter_feature_5: 'WhatsApp bulk messaging',
            starter_feature_6: 'Chatbot for lead generation',
            team: 'Team',
            team_limit_1_name: '4 users minimum',
            team_limit_1_quantity: '$ 15/month',
            team_limit_2_name: 'Add WhatsApp for $20 / month',
            team_channels_1: 'WhatsApp, Instagram',
            team_channels_2: 'Facebook and Web Chat',
            team_feature_0: '3000 conversations / month',
            team_feature_1: 'Support via WhatsApp and email',
            team_feature_2: 'Shared Inbox',
            team_feature_3: 'CRM for customer management',
            team_feature_4: 'Reports and audit',
            team_feature_5: 'WhatsApp bulk messaging',
            team_feature_6: 'Chatbot for lead generation',
            team_feature_7: 'Chatbot for department distribution',
            team_feature_8: 'Chatbots for frequent questions',
            team_feature_9: 'Integration with other systems',
            scale: 'Scale',
            scale_limit_1_name: '6 users minimum',
            scale_limit_1_quantity: '$ 20/month',
            scale_limit_2_name: 'Add WhatsApp for $20 / month',
            scale_channels_1: 'WhatsApp, Instagram',
            scale_channels_2: 'Facebook and Web Chat',
            scale_feature_0: '6000 conversations / month',
            scale_feature_1: 'Support via WhatsApp and email',
            scale_feature_2: 'Shared Inbox',
            scale_feature_3: 'CRM for customer management',
            scale_feature_4: 'Reports and audit',
            scale_feature_5: 'WhatsApp bulk messaging',
            scale_feature_6: 'Chatbot for lead generation',
            scale_feature_7: 'Chatbot for department distribution',
            scale_feature_8: 'Chatbots for frequent questions',
            scale_feature_9: 'Integration with other systems',
            scale_feature_10: 'Advance chatbots builder',
            scale_feature_11: 'Access to Optiwe API',
            scale_feature_12: 'ChatGPT - $50 / month',
            whatsapp_pricing: 'WhatsApp Business API Prices',
            whatsapp_pricing_1:
        'As of February 1, 2022, WhatsApp Business API created a new billing model for Conversations.',
            whatsapp_pricing_2:
        'Companies must pay for each conversation and each conversation lasts for a period of 24 hours.',
            whatsapp_pricing_3:
        'Prices depend on the country and also depend on whether it is a conversation initiated by a customer or by the company.',
            whatsapp_pricing_4: 'First 1000 conversations are free.',
            conversations_pricing_title: 'Add more conversations to your plan',
            conversations_pricing_text_1: 'From $0.02 per conversation (inbound or outbound).',
            conversations_pricing_text_2: 'Learn more about our volumen discount prices.',
            chatgpt_pricing_title: 'Power your chatbots with ChatGPT',
            chatgpt_pricing_text_1: 'Only in Scale Plan. From $50 per month',
            chatgpt_pricing_text_2: 'Integrate ChatGPT with all your business knowledge.',
            select_plan: 'Choose your plan according to your needs',
            features: 'Features',
            price_per_agent: 'Price per customer service agent',
            price_per_agent_1: '$5 / month',
            price_per_agent_2: '$10 / month',
            price_per_agent_3: '$15 / month',
            minimum: 'Minimum number of agents',
            whatsapp_channel_price: 'WhatsApp channel price per line',
            whatsapp_channel_price_1: '$20 / month',
            whatsapp_channel_price_2: '$20 / month',
            whatsapp_channel_price_3: '$20 / month',
            feat_1: 'WhatsApp Business API',
            feat_2: 'Instagram DM',
            feat_3: 'Facebook Messenger',
            feat_4: 'Web chat',
            feat_5: 'Web icons',
            feat_6: 'Multi-agent support module',
            feat_7: 'Chat tags',
            feat_8: 'CRM module',
            feat_9: 'Reports module',
            feat_10: 'Bulk messaging',
            feat_11: 'WhatsApp Marketing',
            feat_12: 'Chatbot lead generator',
            feat_13: 'Chatbot department distribution',
            feat_14: 'Chatbot frequent questions',
            feat_15: 'Agent performance',
            feat_16: 'Integrations with other systems',
            feat_17: 'Advance chatbots builder',
            feat_18: 'Chatbots powered by ChatGPT',
            feat_19: 'API access',
            feat_20: 'Custom integrations',
            talk: "Let's talk!"
        }
    }

    function renderSignUpButton (buttonText) {
        if (lang === 'en') {
            return (
                <OptBtn isLink rounded small href="/sign-up/">
                    {text[lang][buttonText]}
                </OptBtn>
            )
        }

        if (lang === 'es') {
            return (
                <OptBtn isLink rounded small href="/es/crear-cuenta/">
                    {text[lang][buttonText]}
                </OptBtn>
            )
        }

        throw new Error('Language not supported')
    }

    return (
        <Layout lang={lang}>
            <SEO
                title={text[lang].page_title}
                description={text[lang].page_description}
                lang={text[lang].page_lang}
                locales={[
                    { hreflang: 'en', href: 'https://optiwe.com/pricing/' },
                    { hreflang: 'es', href: 'https://optiwe.com/es/precios/' },
                    { hreflang: 'x-default', href: 'https://optiwe.com/pricing/' }
                ]}
            />

            <main className="container-fluid ow-banner">
                {/*
                ^*********
                * HEADER *
                **********
                */}
                <Nav
                    lang={lang}
                    showButtons
                />

                {/*
                 ***************
                 * MAIN BANNER *
                 ***************
                 * TODO: If the banner is used in another view, create a <Banner /> component
                 */}
                <div className="container ow-banner__content">
                    <div className="row">
                        <div className="col-xl-6 col-xxl-6 ow-banner__home-content">
                            <h1 className="ow-banner__title">{text[lang].h1_normal}</h1>
                            <p className="ow-banner__text">{text[lang].h1_description_1}</p>
                        </div>
                        <div className="col-md-6 col-xxl-7 ow-banner__home-image">
                            <img src={bannerImg} alt="optiwe" className="ow-banner__img" />
                        </div>
                    </div>
                </div>
            </main>

            {/*
            ^**********
            * PRICING *
            ***********
            */}
            <section className="ow-section ow-section--pricing">
                <div className="container-xl mt-5">
                    <div className="row-pricing-card mt-5">
                        <div className="col-pricing-card">
                            <PricingCard
                                lang={text[lang].page_lang}
                                actionButton={() => (
                                    <div
                                        style={{
                                            margin: '20px 0',
                                            fontSize: '1.5rem',
                                            color: '#fd6a56'
                                        }}
                                    >
                                        {renderSignUpButton('create_account')}
                                    </div>
                                )}
                                plan={{
                                    name: text[lang].starter,
                                    price: 10,
                                    limits: [
                                        {
                                            name: text[lang].starter_limit_1_name,
                                            quantity: text[lang].starter_limit_1_quantity,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].starter_limit_2_name,
                                            disabled: false
                                        }
                                    ],
                                    channels: [
                                        {
                                            name: text[lang].starter_channels_1,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].starter_channels_2,
                                            quantity: null,
                                            disabled: false
                                        }
                                    ],
                                    features: [
                                        {
                                            name: text[lang].starter_feature_0,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].starter_feature_1,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].starter_feature_2,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].starter_feature_3,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].starter_feature_4,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].starter_feature_5,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].starter_feature_6,
                                            quantity: null,
                                            disabled: false
                                        }
                                    ]
                                }}
                            />
                        </div>
                        <div className="col-pricing-card">
                            <PricingCard
                                lang={text[lang].page_lang}
                                actionButton={() => (
                                    <div
                                        style={{
                                            margin: '20px 0',
                                            fontSize: '1.5rem',
                                            color: '#fd6a56'
                                        }}
                                    >
                                        {renderSignUpButton('create_account')}
                                    </div>
                                )}
                                plan={{
                                    name: text[lang].team,
                                    price: 15,
                                    limits: [
                                        {
                                            name: text[lang].team_limit_1_name,
                                            quantity: text[lang].starter_limit_1_quantity,
                                            disabled: false
                                        },
                                        { name: text[lang].team_limit_2_name, disabled: false }
                                    ],
                                    channels: [
                                        {
                                            name: text[lang].team_channels_1,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].team_channels_2,
                                            quantity: null,
                                            disabled: false
                                        }
                                    ],
                                    features: [
                                        {
                                            name: text[lang].team_feature_0,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].team_feature_1,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].team_feature_2,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].team_feature_3,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].team_feature_4,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].team_feature_5,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].team_feature_6,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].team_feature_7,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].team_feature_8,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].team_feature_9,
                                            quantity: null,
                                            disabled: false
                                        }
                                    ]
                                }}
                            />
                        </div>
                        <div className="col-pricing-card">
                            <PricingCard
                                lang={text[lang].page_lang}
                                actionButton={() => (
                                    <div
                                        style={{
                                            margin: '20px 0',
                                            fontSize: '1.5rem',
                                            color: '#fd6a56'
                                        }}
                                    >
                                        {renderSignUpButton('create_account')}
                                    </div>
                                )}
                                plan={{
                                    name: text[lang].scale,
                                    price: 20,
                                    limits: [
                                        {
                                            name: text[lang].scale_limit_1_name,
                                            quantity: text[lang].starter_limit_1_quantity,
                                            disabled: false
                                        },
                                        { name: text[lang].scale_limit_2_name, disabled: false }
                                    ],
                                    channels: [
                                        {
                                            name: text[lang].scale_channels_1,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].scale_channels_2,
                                            quantity: null,
                                            disabled: false
                                        }
                                    ],
                                    features: [
                                        {
                                            name: text[lang].scale_feature_0,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].scale_feature_1,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].scale_feature_2,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].scale_feature_3,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].scale_feature_4,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].scale_feature_5,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].scale_feature_6,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].scale_feature_7,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].scale_feature_8,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].scale_feature_9,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].scale_feature_10,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].scale_feature_11,
                                            quantity: null,
                                            disabled: false
                                        },
                                        {
                                            name: text[lang].scale_feature_12,
                                            quantity: null,
                                            disabled: false
                                        }
                                    ]
                                }}
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/*
            ************
            * CUSTOMERS *
            ************
            */}
            <section className="benefits-shapes">
                <svg
                    id="benefits_top_shape"
                    data-name="benefits_top_shape"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid slice"
                    viewBox="0 0 1920 143.11"
                >
                    <path
                        className="benefits_top_shape"
                        d="M1920,143.11V38.75C1692.68,104.88,1412.86,127.9,1184.41,89,1083.28,71.8,983,44.3,880.43,45.1,705.88,46.4,536.94,129.6,363.09,114c-77.32-7-151.94-33.2-229.26-39.5C89,70.85,41.09,75.79,0,92.94l.22,50.16Z"
                    />
                    <path
                        className="benefits_top_shape"
                        d="M384,72.49c5.25-.88,10.65-1.89,15.23-4.62s8.23-7.75,7.92-13-4.74-9.86-9.87-11.6-10.8-1-15.93.58c-4,1.19-8.2,3-12.06,1.58-4.14-1.57-6.17-6-8.85-9.53C353,25.85,337.1,22.4,327.17,30c-6,4.54-9.81,15.35-7.06,22.55a25.66,25.66,0,0,0,5.42,8c6.64,6.93,17.09,14.23,27,15.22S374,74.25,384,72.49Z"
                    />
                    <path
                        className="benefits_top_shape"
                        d="M443.55,31.61c3.18-3.33,5.56-8.65,2.74-12.32-2.34-3-7.15-3-10.31-.93-1.72,1.09-4.24,3.37-4.92,5.41-1.2,3.23-1.83,9.65,1.81,11.43C436.71,37.19,440.95,34.38,443.55,31.61Z"
                    />
                </svg>
                <div className="container-fluid ow-section--ws-pricing">
                    <div className="container pricing">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="ow-card ow-card--shadow ws-card ws-card-cost">
                                    <p className="ws-card__price">
                                        <strong>{text[lang].conversations_pricing_title}</strong>
                                    </p>
                                    <p className="ws-card__text">
                                        {text[lang].conversations_pricing_text_1}    
                                    </p>
                                    <p className="ws-card__text">
                                        {text[lang].conversations_pricing_text_2} 
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="ow-card ow-card--shadow ws-card ws-card-cost">
                                    <p className="ws-card__price">
                                        <strong>{text[lang].chatgpt_pricing_title}</strong>
                                    </p>
                                    <p className="ws-card__text">
                                        {text[lang].chatgpt_pricing_text_1}
                                    </p>
                                    <p className="ws-card__text">
                                        {text[lang].chatgpt_pricing_text_2} 
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid ow-section--ws-pricing">
                    <div className="container pricing">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="ow-card ow-card--shadow ws-card ws-card-cost">
                                    <p className="ws-card__price">
                                        <strong>{text[lang].whatsapp_pricing}</strong>
                                    </p>
                                    <p className="ws-card__text">
                                        {text[lang].whatsapp_pricing_1}
                                    </p>
                                    <p className="ws-card__text">
                                        {text[lang].whatsapp_pricing_2}
                                    </p>
                                    <p className="ws-card__text">
                                        {text[lang].whatsapp_pricing_3}
                                    </p>
                                    <p className="ws-card__text">
                                        {text[lang].whatsapp_pricing_4}
                                    </p>
                                    <OptBtn
                                        isLink
                                        href="https://developers.facebook.com/docs/whatsapp/pricing/"
                                        rounded
                                        small
                                        className="ws-button"
                                    >
                                        Ver precios de WhatsApp
                                    </OptBtn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <svg
                    id="benefits_bottom_shape"
                    className="benefits_bottom_shape"
                    preserveAspectRatio="xMidYMid slice"
                    viewBox="0 0 1920 143.11"
                    data-name="benefits_bottom_shape"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        className="benefits_bottom_shape"
                        d="M0,0V25.07C100.42,73.33,222.92,85.71,339.3,81.39c156.8-5.8,310.1-35.9,467.5-35.3,150.2.5,300.5,20.5,450.6,13.9,134.5-5.9,267.1-42.9,402.7-27.6,84,9.52,172.75,28.69,259.9,33.2V0Z"
                    />
                </svg>
            </section>

            <section className="container-fluid ow-section ow-section--table-pricing">
                <div className="container">
                    <div className="table-pricing-title">
                        <h2 className="ow-section__title">
                            <span className="bold">{text[lang].select_plan}</span>
                        </h2>
                    </div>
                    <div className="pricing-table">
                        <div className="pricing-table__row pricing-table__row--header">
                            <p className="pricing-table__title">{text[lang].features}</p>
                            <p className="pricing-table__price-title">{text[lang].starter}</p>
                            <p className="pricing-table__price-title">{text[lang].team}</p>
                            <p className="pricing-table__price-title">{text[lang].scale}</p>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row">
                                <p className="pricing-table__col-title">
                                    {text[lang].price_per_agent}
                                </p>
                                <p className="pricing-table__col">
                                    {text[lang].price_per_agent_1}
                                </p>
                                <p className="pricing-table__col">
                                    {text[lang].price_per_agent_2}
                                </p>
                                <p className="pricing-table__col">
                                    {text[lang].price_per_agent_3}
                                </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row">
                                <p className="pricing-table__col-title">{text[lang].minimum}</p>
                                <p className="pricing-table__col">2</p>
                                <p className="pricing-table__col">4</p>
                                <p className="pricing-table__col">6</p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row">
                                <p className="pricing-table__col-title">
                                    {text[lang].whatsapp_channel_price}
                                </p>
                                <p className="pricing-table__col">
                                    {text[lang].whatsapp_channel_price_1}
                                </p>
                                <p className="pricing-table__col">
                                    {text[lang].whatsapp_channel_price_2}
                                </p>
                                <p className="pricing-table__col">
                                    {text[lang].whatsapp_channel_price_3}
                                </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_1}</p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_2}</p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_3}</p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_4}</p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_5}</p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_6}</p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_7}</p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_8}</p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_9}</p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_10}</p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_11}</p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_12}</p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_13}</p>
                                <p className="pricing-table__col"> </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_14}</p>
                                <p className="pricing-table__col"> </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_15}</p>
                                <p className="pricing-table__col"> </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">{text[lang].feat_16}</p>
                                <p className="pricing-table__col"> </p>
                                <p className="pricing-table__col"> ✓ </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">
                                    {text[lang].feat_17}
                                </p>
                                <p className="pricing-table__col"> </p>
                                <p className="pricing-table__col"> </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">
                                    {text[lang].feat_18}
                                </p>
                                <p className="pricing-table__col"> </p>
                                <p className="pricing-table__col"> </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">
                                    {text[lang].feat_19}
                                </p>
                                <p className="pricing-table__col"> </p>
                                <p className="pricing-table__col"> </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                        <div className="pricing-table__body">
                            <div className="pricing-table__row pricing-table__row--check">
                                <p className="pricing-table__col-title">
                                    {text[lang].feat_20}
                                </p>
                                <p className="pricing-table__col"> </p>
                                <p className="pricing-table__col"> </p>
                                <p className="pricing-table__col"> ✓ </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <br></br>
        </Layout>
    )
}
export default Pricing
